import { render } from "./Barcode.vue?vue&type=template&id=6c5d7cda&ts=true"
import script from "./Barcode.vue?vue&type=script&lang=ts"
export * from "./Barcode.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__